import type amplitude from 'amplitude-js';

import * as ampProperties from './amplitudeProps';

export {ampProperties};

type UserProps = {
  [key: string]: string | number;
};

export const amplitudeFunctions = (sdk: typeof amplitude) => {
  const initialiseAmplitude = async (apiKey: string) => {
    await sdk.getInstance().init(apiKey, '', {
      disableCookies: true,
      includeReferrer: true, //might be useful to get where user is coming from (eg which integration)
      includeUtm: true, //track campaigns (last touch attribution): //https://www.docs.developers.amplitude.com/data/sdks/javascript/#cross-domain-tracking-javascript
    });
  };

  const setAmplitudeUserId = async (userId: number | null) => {
    const stringifiedUserId = userId === null ? null : String(userId);
    await sdk.getInstance().setUserId(stringifiedUserId);
  };

  const setAmplitudeUserProps = async (userProps: UserProps) => {
    await sdk.getInstance().setUserProperties(userProps);
  };

  const setAmplitudeGroup = async (
    value: number | string,
    groupType = 'customer'
  ) => {
    await sdk.getInstance().setGroup(groupType, String(value)); // Amplitude expects a string
  };

  const logAmplitudeEvent = async (eventName: string, eventProps = {}) => {
    await sdk.getInstance().logEvent(eventName, eventProps);
  };

  const regenerateAmplitudeDeviceId = async () => {
    await sdk.getInstance().regenerateDeviceId();
  };

  return {
    initialiseAmplitude,
    setAmplitudeUserId,
    setAmplitudeUserProps,
    setAmplitudeGroup,
    logAmplitudeEvent,
    regenerateAmplitudeDeviceId,
  };
};
